import MediaPlanAssets from './MediaPlanAssets';

export default MediaPlanAssets;
